var React = require('react');
var css = require('./module.scss');

/**
 * 使用方法：
 * <Col span={6} offset={2}>col-6</Col>
 * span: number, 所占宽度，total=24
 * offset: number，偏移量
 */

var Col = React.createClass({
    getInitialState: function() {
        return {
            totalCols: this.props.totalCols || 24
        };
    },

    componentDidMount: function() {},

    render: function() {
        var cls = [
            'fp-col',
            'fp-col-' + (this.props.span || this.state.totalCols)
        ];

        if (this.props.className) {
            cls.push(this.props.className);
        }
        if (this.props.offset) {
            cls.push('fp-offset-' + this.props.offset);
        }

        return <div className={cls.join(' ')} style={this.props.style}>
            {this.props.children}
        </div>;
    }
});

module.exports = Col;



// WEBPACK FOOTER //
// ./component/grid/col.js